import React, {useEffect, useRef, useState} from "react";
import {Button, Image, Link, ModalBody, ModalContent, ModalFooter, ModalHeader} from "@nextui-org/react";
import {useVending} from "./VendingProvider";
import {getTransactionStatus, rollbackTransaction} from "../API";

export const ShowImage = ({timer}) => {
    const {qrData, Reseting} = useVending()
    const [minutes, setMinutes] = useState(2);
    const [seconds, setSeconds] = useState(0);
    const [lastHour, setLastHour] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const timerId = useRef(null);

    useEffect(() => {

        setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        if (!isMobile) return;

        const focus = () => {
            if (document.hidden) {
                setLastHour(new Date());
            } else {
                const currentHour = new Date();
                if (lastHour) {
                    const msDiff = currentHour - lastHour;
                    const secondsElapsed = Math.floor(msDiff / 1000);

                    const timeLeftInSeconds = minutes * 60 + seconds - secondsElapsed;

                    if (timeLeftInSeconds <= 0) {
                        clearInterval(timerId.current);
                        setMinutes(0);
                        setSeconds(0);
                        GetCurrentStatus();
                    } else {
                        const totalSecondsRemaining = minutes * 60 + seconds;
                        const secondsSincePause = totalSecondsRemaining - timeLeftInSeconds;

                        if (secondsSincePause >= 5) {
                            GetCurrentStatus();
                        }

                        setMinutes(Math.floor(timeLeftInSeconds / 60));
                        setSeconds(timeLeftInSeconds % 60);
                    }
                }
            }
        };

        document.addEventListener('visibilitychange', focus);

        return () => {
            document.removeEventListener('visibilitychange', focus);
        };
    }, [lastHour, minutes, seconds]);

    useEffect(() => {
        const updateTimer = () => {
            setSeconds((prevSeconds) => {
                if (prevSeconds === 0) {
                    if (minutes === 0) {
                        clearInterval(timerId.current);
                        Rollback();
                        return 0;
                    } else {
                        setMinutes((prevMinutes) => prevMinutes - 1);
                        return 59;
                    }
                } else {
                    return prevSeconds - 1;
                }
            });
        };

        timerId.current = setInterval(updateTimer, 1000);

        return () => clearInterval(timerId.current);
    }, [minutes]);

    async function Rollback() {
        setIsLoading(true);
        const data = await rollbackTransaction(qrData.qr_express.hook_alias);
        Reseting();
    }

    async function GetCurrentStatus() {
        setIsLoading(true);
        const data = await getTransactionStatus(qrData.qr_express.hook_alias);
        switch (data.status) {
            case 'AP':
            case 'RO':
                Reseting();
                break;
            case 'RE':
                Rollback();
                break;
        }
    }

    return (
        <ModalContent>
            <ModalHeader className="flex flex-col gap-1">Escanee el codigo QR con la aplicacion de su
                banco</ModalHeader>
            <ModalBody>
                <p className="text-center">
                    Dispone de: <b>{minutes} minutos {seconds} segundos</b>
                </p>
                <div className="loading-container">
                    <Image
                        width={300}
                        alt="QR Bancard"
                        src={qrData.qr_express.url}
                    />
                </div>
                {
                    isMobile && (
                        <div className="flex justify-center">
                            <Button as={Link} href={qrData.qr_express.url} download={true} target="_blank"
                                  className="w-1/2" color="success" variant="ghost">
                                Descargar
                            </Button>
                        </div>
                    )

                }

            </ModalBody>
            <ModalFooter className="flex justify-center">{/*<b className="text-center">NO ACTUALICE ESTA PAGINA!!</b>*/}<Button
                variant="ghost" color="danger" onPress={Rollback} isLoading={isLoading}>Cancelar
                pedido</Button></ModalFooter>
        </ModalContent>
    )
}

